import { DAY_MILLISECONDS } from './date/constants';

export const DEFAULT_FAVICON_HEAD_LINK = {
  link: [
    {
      rel: 'icon',
      type: 'image/x-icon',
      href: '/favicon-7bit.ico',
    },
  ],
};

export const DEFAULT_CURRENCIES = [];

export const COMMON_REQUEST_INTERVAL = 300000;
export const PAYMENTS_REQUEST_INTERVAL = 150000;
export const NOTIFS_REQUEST_INTERVAL = 60000;

export const DAYS_AMOUNT_TO_SHOW_FINISHED_RACES = 30;

export const FOUR_DEPOSITS_GROUP = 'Dep=4+ Lifetime';

export const LIVE_CHAT_UNAUTH_GROUP_ID = 16;
export const LIVE_CHAT_VIP_GROUP_ID = 13;
export const LIVE_CHAT_HAS_SEON_GROUP_ID = 28;
export const LIVE_CHAT_STAG_GROUP_ID = 1;
export const LIVE_CHAT_ONE_DEPOSIT_GROUP_ID = 22;
export const VIP_GROUPS_FOR_LIVE_CHAT = ['group_1128', 'group_1126', 'VIP_Players'];
export const ONE_DEP_GROUPS_FOR_LIVE_CHAT = ['1dep_for_LC'];

export const TOURNAMENT_GROUP_ID_FOUR_DEPOSIT = 125;

export const CRYPTO_DEP_PROVIDER_ID = 'coinspaid-121';

export const WINNERS_REQUEST_INTERWAL = 5000;
export const LAST_WINNERS_COUNT_TO_SHOW_ON_GAMEPAGE = 10;
export const LAST_WINNERS_COUNT_TO_SHOW_ON_MAIN = 5;

export const HISTORY_TABLE_ITEMS_PER_PAGE = 6;

export const COUNTRYS_WITH_BANNED_LIVE = ['fr', 'us'];
export const CRYPTO_COUNTRIES = [
  'KR',
  'AR',
  'MA',
  'CR',
  'UY',
  'UZ',
  'CL',
  'VE',
  'CO',
  'PR',
  'PE',
  'US',
  'MX',
  'FR',
  'AS',
];

export const BONUS_ABUSER_GROUP = 'Seon';

export const GAME_SORTING_GROUP_MAP: Record<string, string> = {
  HIVOL: 'hitshigh',
  HIVOL_test: 'hitshigh',
  LOVOL: 'hitslow',
  LOVOL_test: 'hitslow',
};
export const GROUPS_FOR_SOME_GAMES_PROVIDER = [
  'pragmaticexternal_au',
  'playtech_au',
  'playtech_ca',
  'pragmaticexternal_ca',
];

export const USER_REMOVED_CARD_GROUP = 'removedcard';

export const SHORT_DEP_RECENT_TRANSACTION_PERIOD = DAY_MILLISECONDS * 30;
export const SHORT_DEP_TEST_GROUP = '1Click-Dep';

export const BLOCKED_CURRENCIES = ['NOK', 'RUB', 'JPY', 'BRL'];

export const STORAGE_BONUS_ABUSER_KEY = 'isFraudEmail';
export const HAD_SIGNIN_STORAGE_KEY = 'isHadSignIn';

export const EMAIL_REGEXP =
  /^[a-zA-Z0-9.!#$%&'*+-_]+@[a-zA-Z0-9]+([-.][a-zA-Z0-9]+)*\.[a-zA-Z0-9]+([-.][a-zA-Z0-9]+)*$/;

export const PROMO_TYPE_GROUPS = {
  on_dep: 'on_dep_offer',
  no_dep: 'no_dep_offer',
  min_dep: 'min_dep_offer',
};

export const MAX_LIMIT_SS = '100000000000000000';
export const SETTINGS_PAGE = '/account-settings';
export const LIMITS_PAGE = '/responsible-gaming';

export const METHOD_BUYCRYPTO_MIN_AMOUNT = 20;
export const METHOD_BUYCRYPTO_MAX_AMOUNT = 25000;
export const METHOD_BUYCRYPTO_DEFAULT_AMOUNT = '50';
